import React, { useState } from "react";
import "./About.css";
import { FaPlus, FaMinus } from "react-icons/fa";
import { Link } from "react-router-dom";
const faqs = [
 {
  question: "What is AstroLogical Solutions™?",
  answer:
    "AstroLogical Solutions™ is an integrated platform offering Astrology, Numerology, Vastu Consultancy, and Spiritual Products. Our mission is to provide meaningful guidance and practical spiritual solutions to help individuals make informed decisions in different aspects of life.",
},
{
  question: "What services does AstroLogical Solutions™ offer?",
  answer:
    "We offer a comprehensive range of services, including Birth Chart Analysis, Career and Business Guidance, Marriage and Relationship Consultation, Numerology, Mobile Number Analysis, Name Correction, Vastu Consultation, and personalized astrological remedies. We also offer carefully selected spiritual products.",
},
{
  question:
    "How can AstroLogical Solutions™ help me in my personal and professional life?",
  answer:
    "Our consultations aim to provide insights into career, business, relationships, personal development, and living or working environments through traditional astrological, numerological, and Vastu principles. Our goal is to help you understand potential opportunities and make more informed decisions.",
},
{
  question:
    "How can I book a consultation with AstroLogical Solutions™?",
  answer:
    "You can explore our consultation services on our website, select the service that suits your requirements, and follow the booking and payment process provided. Please share the necessary details requested for your selected consultation so that we can assist you appropriately.",
},
{
  question: "Why should I choose AstroLogical Solutions™?",
  answer:
    "AstroLogical Solutions™ brings Astrology, Numerology, Vastu, and Spiritual Products together under one platform. We focus on personalized guidance, a customer-centric approach, transparent service information, and a convenient online experience to help customers explore solutions suited to their individual needs.",
},
];

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="about-faq-section">
      <div className="about-faq-container">
        <div className="about-faq-left">
          <h2 className="about-faq-title">
            Frequently Asked Questions{" "}
            <div className="about-heading-line">
              <img
                src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
                alt="Heading decoration"
              />
            </div>
          </h2>

          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`about-faq-item ${
                activeIndex === index ? "about-active" : ""
              }`}
            >
              <button
                className="about-faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>

                {activeIndex === index ? <FaMinus /> : <FaPlus />}
              </button>

              <div
                className={`about-faq-answer ${
                  activeIndex === index ? "about-show" : ""
                }`}
              >
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="about-consultation-card">
          <div className="about-consultation-content">
            <div className="about-consultation-text">
              <h2>
                Need Help Choosing
                <br />
                the Right Rudraksha?
              </h2>

              <p>
                Talk with our Spiritual Expert
                <br />
                Get personalized guidance for your life path.
              </p>

              <Link to="/contact">
                <button className="about-consult-btn">
                 Get Consultation
                </button>
              </Link>

              {/* <div className="about-contact-list">
                <div className="about-contact-item">
                  <FaPhoneAlt className="about-phone" />

                  <div>
                    <small>
                      <a
                        href="https://api.whatsapp.com/send/?phone=917351519573&text=Hello+Astro+Logical+Solutions%2C+I+would+like+some+guidance.&type=phone_number&app_absent=0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        +91 7351739191
                      </a>
                    </small>
                  </div>
                </div>

                <div className="about-contact-item">
                  <FaEnvelope className="about-email" />

                  <div>
                    <small>
                      <a
                        class="number"
                        href="mailto:support@astrologicalsolutions.in"
                      >
                        support@astrologicalsolutions.in
                      </a>
                    </small>
                  </div>
                </div>
              </div> */}
            </div>

            <div className="about-consultation-image">
              <img
                src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786004377/45813b9c6c33c11c7ffca772ce0ca80e-removebg-preview_nkshnu.png"
                alt="Rudraksha"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
